import React from 'react';
import { XRayIntegrations } from '../../Integrations/NativeIntegrations/components/XRayIngegrations/XRayIntegrations';
import styles from './XRayLeads.module.css';

export const XRayLeads = () => (
  <div className={styles.container}>
    <div className={styles.header}>X-Ray Pixel</div>
    <XRayIntegrations />
  </div>
);
